import type { GetDashboardJobsQuery } from 'src/graphql/generated';
import type { HeroMode, DashboardTalentSearchUserContext } from 'src/types';

interface Options {
  tsContext: DashboardTalentSearchUserContext | null;
  jobsInfo: GetDashboardJobsQuery | undefined;
}
export const heroVariantSelector = ({
  tsContext,
  jobsInfo,
}: Options): HeroMode => {
  if (tsContext?.hasPTSClaim) {
    return 'PTSHirer';
  }

  if (
    jobsInfo?.dashboardJobsCounts?.__typename !==
    'DashboardJobsCountsResponseSuccess'
  ) {
    return 'ExistingHirer';
  }

  const { draftsCount, directExpired, directPosted } =
    jobsInfo.dashboardJobsCounts;

  const hasNoJobs =
    draftsCount === 0 && directPosted === 0 && directExpired === 0;

  const hasOnlyOneDraft =
    draftsCount === 1 && directPosted === 0 && directExpired === 0;

  if (hasNoJobs || hasOnlyOneDraft) {
    return 'NewHirer';
  }

  return 'ExistingHirer';
};
